import google_translate from './google_translate/google_translate';

const reducers = {
    google_translate,
};

export default reducers;